import {
  GridColumnMenuFilter,
  GridColumnMenuItem,
  GridColumnMenuItemContent,
  GridColumnMenuItemGroup,
  GridColumnMenuProps,
  GridColumnMenuSort,
  GridColumnProps,
} from '@progress/kendo-react-grid';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useColumnMenu } from './useColumnMenu';

export type ColumnProps = GridColumnProps & { show: boolean };

type Props = {
  columns: ColumnProps[];
  onColumnsSubmit: (columns: ColumnProps[]) => void;
} & GridColumnMenuProps;

export const ColumnMenu: React.FC<Props> = (props: Props) => {
  const { columns: receivedColumns, onColumnsSubmit, onCloseMenu } = props;
  const { t } = useTranslation();
  const {
    columns,
    columnsExpanded,
    filterExpanded,
    onToggleColumn,
    onReset,
    onSubmit,
    onColumnsClick,
    onFilterExpandChange,
  } = useColumnMenu(receivedColumns, onColumnsSubmit, onCloseMenu);
  const oneVisibleColumn = columns.filter((c) => c.show).length === 1;

  return (
    <>
      <GridColumnMenuSort {...props} />
      <GridColumnMenuFilter
        {...props}
        onExpandChange={onFilterExpandChange}
        expanded={filterExpanded}
      />
      <GridColumnMenuItemGroup>
        <GridColumnMenuItem
          title={t('columns')}
          iconClass={'k-i-columns'}
          onClick={onColumnsClick}
        />
        <GridColumnMenuItemContent show={columnsExpanded}>
          <div className={'k-column-list-wrapper'}>
            <form onSubmit={onSubmit} onReset={onReset}>
              <div className={'k-column-list'}>
                {columns.map((column, idx) => (
                  <div key={idx} className={'k-column-list-item'}>
                    <span>
                      <input
                        id={`column-visiblity-show-${idx}`}
                        className="k-checkbox"
                        type="checkbox"
                        readOnly={true}
                        disabled={column.show && oneVisibleColumn}
                        checked={column.show}
                        onClick={() => onToggleColumn(idx)}
                      />
                      <label
                        htmlFor={`column-visiblity-show-${idx}`}
                        className="k-checkbox-label"
                        style={{ userSelect: 'none' }}
                      >
                        {column.title}
                      </label>
                    </span>
                  </div>
                ))}
              </div>
              <div className={'k-columnmenu-actions'}>
                <button type={'reset'} className={'k-button'}>
                  {t('reset')}
                </button>
                <button className={'k-button k-primary'}>{t('save')}</button>
              </div>
            </form>
          </div>
        </GridColumnMenuItemContent>
      </GridColumnMenuItemGroup>
    </>
  );
};
